module.exports = {
  context: {
    input: {
      placeholder: 'Search'
    },
    submitButton: {
      text: 'Search',
      class: 'search-submit'
    },
    closeButton: {
      ariaLabel: 'Close'
    },
    form_action: '/components/preview/search-bar'
  }
}
